import { render, staticRenderFns } from "./CenarioCabecalho.vue?vue&type=template&id=2ef01c59&scoped=true&"
import script from "./CenarioCabecalho.vue?vue&type=script&lang=js&"
export * from "./CenarioCabecalho.vue?vue&type=script&lang=js&"
import style0 from "./CenarioCabecalho.vue?vue&type=style&index=0&id=2ef01c59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef01c59",
  null
  
)

export default component.exports